<div class="w-full">
  @if (label) {
    <label class="text-sm font-medium text-metro-black mb-1 block">
      {{ label }}
    </label>
  }

  <div class="relative">
    <div
      class="flex items-center input-base overflow-hidden border rounded-lg"
      [ngClass]="{
        'text-sm px-2 py-1': size === 'sm',
        'text-base px-3 py-2': size === 'md',
        'text-lg px-4 py-3': size === 'lg',
        'border-red-500 ring-1 ring-red-400': !isValidDateFormat() && inputValue().length > 0,
        'border-metro-blue': isValidDateFormat() || inputValue().length === 0,
        'cursor-not-allowed opacity-60': disabled
      }"
    >
      <input
        #inputRef
        type="text"
        class="flex-1 outline-none bg-transparent min-w-0 text-metro-black placeholder-gray-400"
        [value]="inputValue()"
        (input)="onInputChange($event.target.value)"
        (keydown)="onKeyDown($event)"
        [placeholder]="placeholder"
        [disabled]="disabled"
      />
      <button type="button" (click)="toggleCalendar(); $event.stopPropagation()" class="flex-shrink-0 ml-1"
        [disabled]="disabled">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-metro-blue-secondary" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path d="M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8" />
          <path d="M16 3v4" />
          <path d="M8 3v4" />
          <path d="M4 11h16" />
          <path d="M16 19h6" />
        </svg>
      </button>
      </div>

    @if (helper && isValidDateFormat()) {
      <p class="text-xs text-metro-blue mt-1">{{ helper }}</p>
    }
    @if (!isValidDateFormat() && inputValue().length > 0) {
      <p class="text-xs text-red-500 mt-1">{{ errorMessage }}</p>
    }

    @if (calendarVisible()) {
      <div #calendarRef 
        class="absolute z-50"
        [ngClass]="{
          'top-full mt-1': calendarPosition() === 'bottom',
          'bottom-full mb-1': calendarPosition() === 'top',
          'left-0': calendarAlignment() === 'left',
          'right-0': calendarAlignment() === 'right'
        }">
        <app-metro-date-picker
          [modeInput]="mode()"
          [selectedDateInput]="selectedDate()"
          [startDateInput]="startDate()"
          [endDateInput]="endDate()"
          (dateSelected)="onSingleSelected($event)"
          (rangeSelected)="onRangeSelected($event)"
        ></app-metro-date-picker>
      </div>
    }
  </div>
</div>
